export default __webpack_public_path__ + "static/media/157.e0cfa5d0.jpg";